import { render, staticRenderFns } from "./AdminAvaliacoes.vue?vue&type=template&id=41301e24&scoped=true"
import script from "./AdminAvaliacoes.vue?vue&type=script&lang=js"
export * from "./AdminAvaliacoes.vue?vue&type=script&lang=js"
import style0 from "@/assets/admin-styles.css?vue&type=style&index=0&id=41301e24&prod&scoped=true&lang=css&external"
import style1 from "./AdminAvaliacoes.vue?vue&type=style&index=1&id=41301e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41301e24",
  null
  
)

export default component.exports